import { TableColumn } from "react-data-table-component";
import { Link } from "react-router-dom";
import { LI, UL } from "../../AbstractElements";
import { ServiceRowType, ServiceStatus } from "../../Types/ServiceManagement";
import {
  CompanyRoleTableActionTypes,
  FormAccess,
} from "../../Types/UserManagement";
import { ServiceRequestManagementRoute } from "../../utils/Constant";
import { format } from 'date-fns';
export const RequestColumnStructure: TableColumn<ServiceRowType>[] = [
  {
    name: "Request ID",
    selector: (row) => row.id,
    sortable: true,
    center: false,
  },
  {
    name: "Service Name",
    selector: (row) => `${row.serviceType?.name}`,
    sortable: true,
    center: true,
  },
  {
    name: "Date",
    selector: (row) => format(new Date(row.serviceDate), 'yyyy/MM/dd') ,
    sortable: true,
    center: true,
  },
  {
    name: "Time",
    selector: (row) => row.serviceTime,
    sortable: true,
    center: true,
  },
  {
    name: "User",
    selector: (row) => `${row.firstName} ${row.lastName}`,
    sortable: true,
    center: true,
  },
  {
    name: "Status",
    selector: (row) => row.status,
    sortable: true,
    center: true,
    cell: (row) => {
      if (row.status === ServiceStatus.NEW) {
        return <p>New</p>;
      }
      return <p>{row.status}</p>;
    },
  },
  {
    name: "Action",
    cell: (row) => (
      <TableActions
        id={row.id}
        setCentered={row.setCentered}
        modalDetails={row.modalDetails}
      />
    ),
    sortable: true,
    center: true,
  },
];

const TableActions: React.FC<CompanyRoleTableActionTypes> = ({
  id,
  setCentered,
  modalDetails,
}) => {
  const handleDeleteClick = () => {
    setCentered && setCentered(true);
    modalDetails &&
      modalDetails({
        id,
        type: FormAccess.DELETE,
      });
  };

  return (
    <UL className="action simple-list flex-row gap-2" id={id}>
       
      <LI className="create" aria-disabled onClick={handleDeleteClick}>
        <Link to={`/${ServiceRequestManagementRoute}/${id}`}>
        <i className="icon-eye" />
        </Link>
      </LI>
    </UL>
  );
};
